import { render, staticRenderFns } from "./GlobalDetail.vue?vue&type=template&id=517b5a47"
import script from "./GlobalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GlobalDetail.vue?vue&type=style&index=0&id=517b5a47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports